<template>
    <div class="blogroll-container">
        <div class="line"></div>
        <div class="title-box">
            <span class="title">友情链接</span>
        </div>
        <div class="list-box">
            <ul>
                <li v-for="(item, i) in blogrollList" :key="i">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BlogrollComponent',
    data() {
        return {
            blogrollList: []
        }
    },
    created() {
        this.getBlogrollList();
    },
    methods: {
        getBlogrollList() {
            this.blogrollList = [
                { name: '新浪游戏' },
                { name: '中华网游戏' },
                { name: '第三每天游戏' },
                { name: '40407发号中心' },
                { name: '齐鲁网游戏' },
                { name: '手游那点事' },
                { name: '游戏狗手机游戏网' },
                { name: '盒子游戏新闻' },
                { name: '要我玩游戏网' },
                { name: '凤凰网游戏' },
                { name: '超完最新网游' },
                { name: '桃花源记' },
                { name: '361游戏' },
                { name: '智游网' },
                { name: 'lookgame' },
                { name: '极击网' },
                { name: '搞趣网' },
                { name: '搜狐应用中心' },
                { name: '1UP游戏机' },
                { name: '爱玩网' },
                { name: '小鹰VR' },
                { name: '青亭网' },
                { name: '区块链游戏导航' }
            ];
        },
    }
}
</script>
<style lang="scss" scoped>
@import './BlogrollComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/blogroll/BlogrollComponent.vue